<!-- Layout -->
<template>
    <div>
        <el-container>
            <el-header>
                <Headers />
            </el-header>
            <el-main>
                <Content />
            </el-main>
            <el-footer>
                <Footers />
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import Headers from '@/components/Header.vue'
import Content from '@/components/Content.vue'
import Footers from '@/components/FooterNew.vue'
export default {
    name: 'layout',
    components: {
        Headers,
        Content,
        Footers
    },
    data () {
        return {

        }
    },
    created () {

    },
    mounted () {

    },
    methods: {

    }
}
</script>
<style  scoped>
.el-header {
    padding: 0;
}
.el-main {
    padding: 0;
}
.el-footer {
    padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/layout.vue